import { defineQuery as R } from "bitecs";
import "../../core/ecs/components.js";
import { lerp as X } from "../../core/math/utils.js";
import * as K from "three";
import "../../core/validation/schemas.js";
import { Body as l, BodyType as L, SetLinearVelocity as W, SetAngularVelocity as _ } from "../physics/components.js";
import "../physics/recipes.js";
import "../physics/systems.js";
import "../physics/utils.js";
import { Tween as m, TweenValue as T, KinematicTween as k, KinematicRotationTween as E, Sequence as y, Shaker as g, TransformShaker as d, SequenceState as $, ShakerMode as M, TransformShakerAxes as p, TransformShakerType as S } from "./components.js";
import { WorldTransform as a } from "../transforms/components.js";
import "../transforms/systems.js";
import { applyEasing as Y, tweenFieldRegistry as O, sequenceActiveTweens as b, shakerFieldRegistry as v, shakerBaseRegistry as D, transformShakerQuatRegistry as V, transformShakerBaseRegistry as Q, EasingNames as N, sequenceRegistry as J, createTween as U } from "./utils.js";
const q = new K.Quaternion(), G = new K.Euler(), F = Math.PI / 180, B = Object.values(N), tt = R([m]), j = R([T]), et = R([k]), ot = R([E]), nt = R([y]), Z = R([g]), C = R([d]), rt = 180 / Math.PI, it = { x: l.posX, y: l.posY, z: l.posZ }, st = {
  x: l.eulerX,
  y: l.eulerY,
  z: l.eulerZ
}, at = { x: l.velX, y: l.velY, z: l.velZ }, ct = {
  x: l.rotVelX,
  y: l.rotVelY,
  z: l.rotVelZ
};
function z(n, o) {
  return o === 0 ? n.x : o === 1 ? n.y : n.z;
}
function H(n, o, e, t) {
  n.hasComponent(o, e) || (n.addComponent(o, e), e.x[o] = t.x[o], e.y[o] = t.y[o], e.z[o] = t.z[o]);
}
function ut(n, o, e, t, r) {
  if (!n.hasComponent(o, m))
    return { position: t, velocity: 0, done: !0 };
  const i = m.duration[o], s = m.elapsed[o], c = s / i;
  if (c >= 1)
    return { position: t, velocity: 0, done: !0 };
  const u = B[m.easingIndex[o]] || "linear", f = Y(c, u), h = X(e, t, f), w = Y(Math.min((s + r) / i, 1), u), P = (X(e, t, w) - h) / r;
  return { position: h, velocity: P, done: !1 };
}
function ft(n) {
  return n > Math.PI ? n - 2 * Math.PI : n < -Math.PI ? n + 2 * Math.PI : n;
}
function dt(n, o, e, t, r) {
  if (!n.hasComponent(o, m))
    return { rotation: t, angularVelocity: 0, done: !0 };
  const i = m.duration[o], s = m.elapsed[o], c = s / i;
  if (c >= 1)
    return { rotation: t, angularVelocity: 0, done: !0 };
  const u = B[m.easingIndex[o]] || "linear", f = Y(c, u), h = X(e, t, f), w = Y(Math.min((s + r) / i, 1), u), x = X(e, t, w), P = ft(x - h) / r;
  return { rotation: h, angularVelocity: P, done: !1 };
}
const lt = {
  group: "fixed",
  first: !0,
  update(n) {
    const o = n.time.fixedDeltaTime, e = [];
    for (const t of et(n.world)) {
      const r = k.targetEntity[t];
      if (!n.hasComponent(r, l)) {
        e.push(t);
        continue;
      }
      const i = k.axis[t], { position: s, velocity: c, done: u } = ut(
        n,
        k.tweenEntity[t],
        k.from[t],
        k.to[t],
        o
      );
      z(it, i)[r] = s, H(n, r, W, at), z(W, i)[r] = c, k.lastPosition[t] = s, k.targetPosition[t] = s, u && e.push(t);
    }
    for (const t of e) n.destroyEntity(t);
  }
}, Zt = {
  group: "fixed",
  after: [lt],
  update(n) {
    const o = n.time.fixedDeltaTime, e = [];
    for (const t of ot(n.world)) {
      const r = E.targetEntity[t];
      if (!n.hasComponent(r, l)) {
        e.push(t);
        continue;
      }
      const i = E.axis[t], { rotation: s, angularVelocity: c, done: u } = dt(
        n,
        E.tweenEntity[t],
        E.from[t],
        E.to[t],
        o
      );
      z(st, i)[r] = s * rt, H(
        n,
        r,
        _,
        ct
      ), z(_, i)[r] = c, E.lastRotation[t] = s, E.targetRotation[t] = s, u && e.push(t);
    }
    for (const t of e) n.destroyEntity(t);
  }
}, pt = {
  group: "simulation",
  update(n) {
    const o = n.time.deltaTime, e = /* @__PURE__ */ new Set();
    for (const t of tt(n.world)) {
      m.elapsed[t] += o;
      const r = m.elapsed[t] / m.duration[t];
      r >= 1 && e.add(t);
      const i = B[m.easingIndex[t]] || "linear", s = Y(Math.min(r, 1), i);
      for (const c of j(n.world)) {
        if (T.source[c] !== t) continue;
        const u = T.target[c], f = O.get(c);
        if (n.hasComponent(u, l) && l.type[u] === L.KinematicVelocityBased && f && (f === l.posX || f === l.posY || f === l.posZ || f === l.eulerX || f === l.eulerY || f === l.eulerZ)) continue;
        const w = X(
          T.from[c],
          T.to[c],
          s
        );
        T.value[c] = w, f && u < f.length && (f[u] = w);
      }
    }
    for (const t of j(n.world))
      e.has(T.source[t]) && (O.delete(t), n.destroyEntity(t));
    for (const t of e)
      n.destroyEntity(t);
  }
};
function A(n, o) {
  const e = J.get(o);
  if (!e) return;
  let t = y.currentIndex[o];
  if (t >= e.length) return;
  let r = b.get(o);
  for (r || (r = /* @__PURE__ */ new Set(), b.set(o, r)); t < e.length; ) {
    const i = e[t];
    if (i.type === "pause") {
      y.pauseRemaining[o] = i.duration, y.currentIndex[o] = t;
      return;
    }
    if (i.target !== void 0 && i.attr) {
      const s = U(n, i.target, i.attr, {
        from: i.from,
        to: i.to ?? 0,
        duration: i.duration,
        easing: i.easing
      });
      s && r.add(s);
    }
    t++;
  }
  y.currentIndex[o] = t;
}
const It = {
  group: "simulation",
  after: [pt],
  update(n) {
    const o = n.time.deltaTime;
    for (const e of nt(n.world)) {
      if (y.state[e] !== $.Playing) continue;
      const t = y.pauseRemaining[e];
      if (t > 0) {
        y.pauseRemaining[e] = t - o, y.pauseRemaining[e] <= 0 && (y.currentIndex[e]++, A(n, e));
        continue;
      }
      const r = b.get(e);
      if (r && r.size > 0) {
        for (const i of r)
          n.hasComponent(i, m) || r.delete(i);
        if (r.size > 0)
          continue;
        A(n, e);
        continue;
      }
      if (y.currentIndex[e] >= y.itemCount[e]) {
        y.state[e] = $.Idle, y.currentIndex[e] = 0, y.pauseRemaining[e] = 0;
        continue;
      }
      A(n, e);
    }
  }
};
function I(n, o) {
  if (n === S.Position) {
    if (o === p.X) return a.posX;
    if (o === p.Y) return a.posY;
    if (o === p.Z) return a.posZ;
  } else if (n === S.Scale) {
    if (o === p.X) return a.scaleX;
    if (o === p.Y) return a.scaleY;
    if (o === p.Z) return a.scaleZ;
  } else if (n === S.Rotation) {
    if (o === p.X) return a.eulerX;
    if (o === p.Y) return a.eulerY;
    if (o === p.Z) return a.eulerZ;
  }
  return null;
}
const yt = {
  group: "draw",
  first: !0,
  update(n) {
    const o = [
      p.X,
      p.Y,
      p.Z
    ];
    for (const e of C(n.world)) {
      const t = d.target[e];
      if (!n.hasComponent(t, a)) continue;
      const r = d.type[e], i = d.axes[e];
      if (r === S.Rotation)
        V.has(t) || V.set(t, {
          x: a.rotX[t],
          y: a.rotY[t],
          z: a.rotZ[t],
          w: a.rotW[t]
        });
      else
        for (const s of o) {
          if (!(i & s)) continue;
          const c = I(r, s);
          c && Q.set(
            `${e}-${s}`,
            c[t]
          );
        }
    }
    for (const e of C(n.world)) {
      if (d.mode[e] !== M.Additive) continue;
      const t = d.target[e];
      if (!n.hasComponent(t, a)) continue;
      const r = d.type[e];
      if (r === S.Rotation) continue;
      const i = d.axes[e], s = d.value[e], c = d.intensity[e];
      for (const u of o) {
        if (!(i & u)) continue;
        const f = I(r, u);
        f && (f[t] += s * c);
      }
    }
    for (const e of C(n.world)) {
      if (d.mode[e] !== M.Multiplicative)
        continue;
      const t = d.target[e];
      if (!n.hasComponent(t, a)) continue;
      const r = d.type[e];
      if (r === S.Rotation) continue;
      const i = d.axes[e], s = d.value[e], c = d.intensity[e];
      for (const u of o) {
        if (!(i & u)) continue;
        const f = I(r, u);
        f && (f[t] *= 1 + (s - 1) * c);
      }
    }
    for (const e of C(n.world)) {
      if (d.type[e] !== S.Rotation) continue;
      const r = d.target[e];
      if (!n.hasComponent(r, a)) continue;
      const i = d.axes[e], s = d.value[e], c = d.intensity[e], u = s * c * F, f = i & p.X ? u : 0, h = i & p.Y ? u : 0, w = i & p.Z ? u : 0;
      G.set(f, h, w, "YXZ"), q.setFromEuler(G);
      const x = new K.Quaternion(
        a.rotX[r],
        a.rotY[r],
        a.rotZ[r],
        a.rotW[r]
      );
      x.multiply(q), a.rotX[r] = x.x, a.rotY[r] = x.y, a.rotZ[r] = x.z, a.rotW[r] = x.w;
    }
  }
}, mt = {
  group: "draw",
  last: !0,
  update(n) {
    const o = [
      p.X,
      p.Y,
      p.Z
    ];
    for (const e of C(n.world)) {
      const t = d.target[e];
      if (!n.hasComponent(t, a)) continue;
      const r = d.type[e];
      if (r === S.Rotation) continue;
      const i = d.axes[e];
      for (const s of o) {
        if (!(i & s)) continue;
        const c = I(r, s);
        if (!c) continue;
        const u = `${e}-${s}`, f = Q.get(u);
        f !== void 0 && (c[t] = f);
      }
    }
    for (const [e, t] of V)
      n.hasComponent(e, a) && (a.rotX[e] = t.x, a.rotY[e] = t.y, a.rotZ[e] = t.z, a.rotW[e] = t.w);
    V.clear();
  }
}, gt = {
  group: "simulation",
  last: !0,
  update(n) {
    for (const o of Q.keys()) {
      const e = parseInt(o.split("-")[0], 10);
      n.hasComponent(e, d) || Q.delete(o);
    }
  }
}, Mt = {
  group: "draw",
  first: !0,
  before: [yt],
  update(n) {
    for (const o of Z(n.world)) {
      const e = g.target[o], t = v.get(o);
      t && D.set(o, t[e]);
    }
    for (const o of Z(n.world)) {
      if (g.mode[o] !== M.Additive) continue;
      const e = g.target[o], t = v.get(o);
      t && (t[e] += g.value[o] * g.intensity[o]);
    }
    for (const o of Z(n.world)) {
      if (g.mode[o] !== M.Multiplicative) continue;
      const e = g.target[o], t = v.get(o);
      if (!t) continue;
      const r = g.intensity[o], i = g.value[o];
      t[e] *= 1 + (i - 1) * r;
    }
  }
}, Vt = {
  group: "draw",
  last: !0,
  before: [mt],
  update(n) {
    for (const o of Z(n.world)) {
      const e = g.target[o], t = v.get(o);
      if (!t) continue;
      const r = D.get(o);
      r !== void 0 && (t[e] = r);
    }
  }
}, Qt = {
  group: "simulation",
  last: !0,
  before: [gt],
  update(n) {
    for (const o of v.keys())
      n.hasComponent(o, g) || (v.delete(o), D.delete(o));
  }
};
export {
  Zt as KinematicRotationTweenSystem,
  lt as KinematicTweenSystem,
  It as SequenceSystem,
  Mt as ShakerApplySystem,
  Qt as ShakerCleanupSystem,
  Vt as ShakerRestoreSystem,
  yt as TransformShakerApplySystem,
  gt as TransformShakerCleanupSystem,
  mt as TransformShakerRestoreSystem,
  pt as TweenSystem
};
//# sourceMappingURL=systems.js.map
